'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeCSSUnit;

var _lodash = require('lodash.isnumber');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isstring');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function normalizeCSSUnit(unitValue) {
  if (!(0, _lodash2.default)(unitValue) && !(0, _lodash4.default)(unitValue)) {
    throw new TypeError('You need to pass a number or a string as an argument. ' + unitValue.constructor.name + ' provided.');
  }
  return (0, _lodash2.default)(unitValue) ? unitValue + 'px' : unitValue.trim();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/normalize-css-unit/dist/index.js
// module id = 810
// module chunks = 0